import { render, staticRenderFns } from "./EmployeeLookup.vue?vue&type=template&id=08b1b0e2&"
import script from "./EmployeeLookup.vue?vue&type=script&lang=js&"
export * from "./EmployeeLookup.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeLookup.vue?vue&type=style&index=0&id=08b1b0e2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports